import { render } from "./signup-sidebar.vue?vue&type=template&id=72564d7c&scoped=true"
import script from "./signup-sidebar.vue?vue&type=script&lang=js"
export * from "./signup-sidebar.vue?vue&type=script&lang=js"

import "./signup-sidebar.vue?vue&type=style&index=0&id=72564d7c&lang=scss&scoped=true"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72564d7c"]])

export default __exports__